export default "__VITE_ASSET__D4AWygU0__"